export enum DateType {
    TIME_AGO = 1,
    DATE = 2,
}
